import { render, staticRenderFns } from "./HrSalaryInsSocialAdjust.vue?vue&type=template&id=60d9edf6&scoped=true&"
import script from "./HrSalaryInsSocialAdjust.vue?vue&type=script&lang=js&"
export * from "./HrSalaryInsSocialAdjust.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d9edf6",
  null
  
)

export default component.exports